import React from 'react';

import {
  ActionIcon,
  ColorInputProps,
  ColorInput as MantineColorInput,
  Tooltip,
  useMantineTheme,
} from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

// This function generates a random color in HEX format.
const getRandomColor = (): string => {
  // The maximum color value in HEX format is 0xFFFFFF, which equals 16777215 in decimal format.
  const maxColorValue = 16777215;
  // We want to avoid generating white colors, so we set a minimum color value that corresponds to a yellow color (#FFFF00).
  const minColorValue = 2621440;
  // Generate a random color value within the range of minColorValue and maxColorValue.
  const randomColorValue = Math.floor(Math.random() * (maxColorValue - minColorValue) + minColorValue);
  // Convert the random color value to HEX format.
  return `#${randomColorValue.toString(16)}`;
};

const ColorInput = ({ onChange, ...colorInputProps }: ColorInputProps): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <MantineColorInput
      onChange={onChange}
      rightSection={
        <Tooltip label='Get random color'>
          <ActionIcon
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.stopPropagation();
              if (onChange) {
                onChange(getRandomColor());
              }
            }}
          >
            <IconRefresh size={theme.fontSizes.md} />
          </ActionIcon>
        </Tooltip>
      }
      {...colorInputProps}
    />
  );
};

export default ColorInput;
